var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLangMock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 20,
    viewBox: "0 0 40 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.02752 10.625C1.34368 14.1982 4.34464 17 8 17C11.866 17 15 13.866 15 10C15 6.13401 11.866 3 8 3C4.34464 3 1.34368 5.8018 1.02752 9.375H1V10.625H1.02752ZM9.16434 14.4234C8.62059 15.5945 8.11994 15.75 8 15.75C7.88006 15.75 7.37941 15.5945 6.83566 14.4234C6.39855 13.4819 6.08245 12.1553 6.01391 10.625H9.98609C9.91755 12.1553 9.60145 13.4819 9.16434 14.4234ZM9.98609 9.375H6.01391C6.08245 7.84471 6.39855 6.51812 6.83566 5.57664C7.37941 4.4055 7.88006 4.25 8 4.25C8.11994 4.25 8.62059 4.4055 9.16434 5.57664C9.60145 6.51812 9.91755 7.84471 9.98609 9.375ZM11.2372 10.625C11.1593 12.5208 10.7306 14.1994 10.0917 15.3577C12.0476 14.5935 13.4825 12.7893 13.7164 10.625H11.2372ZM13.7164 9.375H11.2372C11.1593 7.47921 10.7306 5.80057 10.0917 4.6423C12.0476 5.40646 13.4825 7.2107 13.7164 9.375ZM4.76278 9.375C4.84066 7.47921 5.26942 5.80057 5.90828 4.6423C3.95242 5.40647 2.51752 7.2107 2.28358 9.375H4.76278ZM2.28358 10.625H4.76278C4.84066 12.5208 5.26943 14.1994 5.90828 15.3577C3.95243 14.5935 2.51752 12.7893 2.28358 10.625Z",
    fill: "#040517",
    fillOpacity: 0.56
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6113 15V4.81818H27.9949V6.14062H23.1476V9.2429H27.6618V10.5604H23.1476V13.6776H28.0545V15H21.6113ZM38.3849 4.81818V15H36.973L31.7976 7.53267H31.7031V15H30.1669V4.81818H31.5888L36.7692 12.2955H36.8636V4.81818H38.3849Z",
    fill: "#040517",
    fillOpacity: 0.56
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangMock);
export default __webpack_public_path__ + "static/media/lang-mock.882990513fc708456ab78044a241b895.svg";
export { ForwardRef as ReactComponent };